import * as PropTypes from 'prop-types';
import * as React from 'react';

const ReverbOrange = 'f6870f';

class SoundcloudEmbed extends React.Component {
  iframeSrc = () => `https://w.soundcloud.com/player/?${$.param(this.urlParams())}`;

  urlParams = () => ({
    url: this.props.url,
    auto_play: false,
    hide_related: true,
    show_comments: false,
    show_user: false,
    show_reposts: false,
    color: ReverbOrange,
  });

  render() {
    return (
      <iframe
        width="100%"
        height={this.props.height}
        scrolling="no"
        frameBorder="no"
        src={this.iframeSrc()}
      />
    );
  }
}

SoundcloudEmbed.PropTypes = {
  url: PropTypes.string.isRequired,
  height: PropTypes.string.isRequired,
};

export default SoundcloudEmbed;



// WEBPACK FOOTER //
// ./javascripts/components/shared/soundcloud_embed.jsx